/**
 * List of events used by product map widget
 *
 */
export const productMap = {
  PRODUCT_MAP_OPENED: 'productMapOpened',
  PRODUCT_MAP_CLOSED: 'productMapClosed',
  ACCOMMODATION_MARKER_CLICKED: 'accommodationMarkerClicked'
}
